module.exports = __webpack_public_path__ + "static/semi-7c024d5fa1c22f35eb8322f2f18ad1da.jpg";